var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{class:_vm.$style['text-wrap']},_vm._l((_vm.word),function(letter,idx){return _c('span',{key:(_vm._uid + "-" + letter + "-" + idx),class:_vm.$style.glitch,attrs:{"data-text":letter}},[_vm._v(_vm._s(letter))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad736ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/glitchtext.vue
// module id = null
// module chunks = 